module.exports = __webpack_public_path__ + "img/routine.41b81954.png";